import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseLearningSectionComponent } from '../../../../shared/learning-section/base-learning-section/base-learning-section.component';
import { TimelineHelper } from '../../../../_helpers/learning-plan-helper/timeline.helper';
import { TimelineDirective } from '../../../../_directives/timeline.directive';
import { EditLearningSectionModalComponent } from '../../modals/edit-learning-section-modal/edit-learning-section-modal.component';
import { TimelineSection } from '../../../../_models/timeline-models/section-listing.model';
import { PlacementStudentV2 } from '../../../../_models';
import { TimelineSectionStudentInfo } from '../../../../_models/timeline-models/timeline-section-student-info.model';
import { FeatureHelperService } from '../../../../_helpers/feature-helper/feature-helper.service';

@Component({
    selector: 'section-base',
    templateUrl: './section-base.component.html',
    styleUrls: ['./section-base.component.css'],
    standalone: false
})
export class SectionBaseComponent implements OnInit {
  @Input() placementId: number;
  @Input() student: TimelineSectionStudentInfo;
  @Input() timelineSection: TimelineSection;
  @Input() subject: string;
  @Input() last: boolean;
  @Input() public editMode: boolean = false;
  @Output() dataChanged = new EventEmitter<boolean>();

  @ViewChild(TimelineDirective, { static: true }) learningSectionDirective!: TimelineDirective;

  public timelineHelper: TimelineHelper = new TimelineHelper();
  public innerComponent: BaseLearningSectionComponent;
  public milestoneLabel: string;
  public anchor: string;
  public sectionTitle: string = '';
  private enableEditMode: boolean = true;
  public minSectionDate: Date = new Date();

  constructor(public dialog: MatDialog,
    private featureHelperService: FeatureHelperService
  ) { 
    this.minSectionDate.setFullYear(this.minSectionDate.getFullYear() - 1);
    this.minSectionDate.setHours(12, 0, 0, 0);
  }

  ngOnInit() {
    if (this.timelineSection) {
      if (this.placementId == 0) {
        this.placementId = this.timelineSection.placementId;
      }
      this.milestoneLabel = this.timelineHelper.getTimelineLabel(this.timelineSection.sectionType, this.timelineSection.sectionDate);
      this.innerComponent = this.learningSectionDirective.renderSection(this.timelineSection, this.editMode, this.placementId, [this.student], this.subject, this.minSectionDate);
      this.innerComponent.reloadRequested.subscribe(() => this.dataChanged.emit(true));
      this.sectionTitle = this.innerComponent.sectionTitle;
      this.anchor = this.buildAnchor(this.timelineSection.sectionType, this.timelineSection.sectionDate);
      this.enableEditMode = this.timelineHelper.enableEditMode(this.timelineSection.sectionType);
    }
  }

  public buildAnchor(type: string, date: string): string {
    let anchor = "";
    
    if (this.timelineSection.sectionType == "milestone") {
      anchor = this.timelineHelper.getTimelineAnchor(date);
    }
    if (this.last == true) {
      anchor = 'last';
    }
    return anchor;
  }

  public openSection(): void {
    const dialogRef = this.innerComponent.openSection(EditLearningSectionModalComponent);
    if (dialogRef) {
      dialogRef.afterClosed().subscribe((reload: boolean) => {
        if (reload) {
          this.dataChanged.emit(true);
        }
      });
    }
  }

  public openButtonClass(): string {
    if (this.timelineSection.sectionType !== 'milestone' && this.timelineSection.sectionType !== 'session') {
      return 'section__close-btn-edit';
    }
    if (this.timelineSection.sectionType === 'session') {
      return 'section__close-btn-view';
    }
  }

  public showOpenButton(): boolean {
    return !this.editMode 
    && this.timelineSection.sectionType !== 'milestone' 
    && this.enableEditMode 
    && this.featureHelperService.hasFeature("ItAdminOnly");
  }
}
